import PropTypes from 'prop-types';
import clsx from 'clsx';
import getTextBasedOnType from './getTextBasedOnType';
import getIconBasedOnType from './getIconBasedOnType';

const defaultProps = {
  roundedFull: false,
};

const propTypes = {
  type: PropTypes.oneOf(['virtual', 'in_person']).isRequired,
  roundedFull: PropTypes.bool,
};

export default function ClassBadge({
  type,
  roundedFull,
}) {
  return (
    <div
      className={clsx(
        'rounded-full text-sm px-3 py-1 inline-flex items-center font-medium',
        {
          'lg:rounded-r-none': roundedFull === false,
          'bg-teal-100 text-teal-900': type === 'virtual', 
          'bg-indigo-100 text-indigo-900': type === 'in_person',
        }
      )}
    >
      <div className="leading-5 py-1 px-2 inline-flex items-center space-x-1">
        <div className="opacity-75">
          {getIconBasedOnType(type)}
        </div>
        <div className="font-mono tracking-tight font-semibold text-xs">
          {getTextBasedOnType(type)}
        </div>
      </div>
    </div>
  );
}

ClassBadge.defaultProps = defaultProps;
ClassBadge.propTypes = propTypes;
